import * as React from 'react';
import clsx from 'clsx';
import { getElementChildren } from '../../../utils';
import { Base } from '../../Base';
import { ListItem } from '../ListItem';
import { jsx as _jsx } from "react/jsx-runtime";
var styles = {
  "root": "OrderedList-root_2ZZnN",
  "item": "OrderedList-item_3_J1c",
  "hasHelp": "OrderedList-hasHelp_O6u6F",
  "plain": "OrderedList-plain_2Os6r",
  "bordered": "OrderedList-bordered_1crX_"
};
function OrderedList({
  variant = 'plain',
  className,
  children,
  ...extraProps
}) {
  let hasHelp = false;
  const elements = getElementChildren(children);
  const items = React.Children.map(elements, child => {
    hasHelp = hasHelp || React.Children.count(child.props.children) > 1;
    return /*#__PURE__*/React.cloneElement(child, {
      flex: true,
      flexAlignItemsCenter: true,
      flexWrap: hasHelp,
      ...child.props,
      className: clsx(child.props.className, styles.item, styles[variant])
    });
  });
  return /*#__PURE__*/_jsx(Base, {
    tagName: "ol",
    margin: "none",
    padding: "none",
    listStyleType: "none",
    className: clsx(styles.root, {
      [styles.hasHelp]: hasHelp
    }, className),
    ...extraProps,
    children: items
  });
}
export { OrderedList };